export default __webpack_public_path__ + "static/media/order-complete.c5cf5aba.svg";